import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";

import APCarousel from "../../../components/APCarousel";
import APButton from "../../../components/buttons/APButton";
import { useAuth } from "../../../providers/AuthProvider";
import { VehicleSettlementSurveyResponse } from "../../../types/Survey";
import VehicleSettlementSurveyResponseCarouselCard from "./VehicleSettlementSurveyResponseCarouselCard";

const VehicleSettlementSurveyResponseCarousel = ({
  responses,
  displayAccounts,
}: {
  responses: VehicleSettlementSurveyResponse[];
  displayAccounts: boolean;
}) => {
  const navigate = useNavigate();
  const { getScopedPageUrl } = useAuth();
  const renderResponse = (response: VehicleSettlementSurveyResponse) => {
    return (
      <Box key={`carousel-${response.id}`}>
        <VehicleSettlementSurveyResponseCarouselCard
          response={response}
          displayAccount={displayAccounts}
          onClick={() => {
            navigate(
              `${getScopedPageUrl(
                "employerViewSurveyFeedback"
              )}?firstResponseId=${response.vehiclesettlementsurveyid}`
            );
          }}
        />
      </Box>
    );
  };

  return (
    <Box>
      <APCarousel
        navigationType="headerArrows"
        autoPlay={true}
        hideArrows={true}
      >
        {responses.map(renderResponse)}
      </APCarousel>
      <Box sx={{ position: "absolute", bottom: 0, right: 0 }}>
        <APButton
          text="Testimonials"
          onClick={() =>
            navigate(getScopedPageUrl("employerViewSurveyFeedback"))
          }
          variant="contained"
          size="large"
        />
      </Box>
    </Box>
  );
};

export default VehicleSettlementSurveyResponseCarousel;
